export default "__VITE_ASSET__x5hlaTNc__"